import React from 'react';
import classNames from 'classnames/bind';
import { arrayOf, number, string } from 'prop-types';
import styles from '../Datepicker.css';
var cx = classNames.bind(styles);
export var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      weekdaysShort = _ref.weekdaysShort;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('Weekday')
  }, weekdaysShort[weekday]);
};
Weekday.propTypes = process.env.NODE_ENV !== "production" ? {
  weekday: number,
  weekdaysShort: arrayOf(string)
} : {};